<template>
  <div class="addclient">
    <div class="card-block">
      <form v-if="!waitForData" @submit.prevent="submitForm" data-testid="registration-address-form">
        <div class="row justify-content-around">
          <span data-testid="registration-address-czech-label">Česká</span>
          <label class="switch switch-lg switch-text switch-primary">
            <input v-model="searchOutsideCzechia" type="checkbox" class="switch-input" id="searchInCzechia" data-testid="registration-address-foreign-toggle">
            <span class="switch-label" data-on="" data-off=""></span>
            <span class="switch-handle"></span>
          </label>
          <span data-testid="registration-address-foreign-label">zahraniční</span>
        </div>
        <template v-if="!searchOutsideCzechia">
          <div class="row justify-content-center">
            <div class="form-group col-md-12">
              <multiselect v-model="selected"
                           :reset-after="true"
                           id="search"
                           data-testid="registration-address-search-czech"
                           label="label"
                           track-by="code"
                           placeholder="vyhledat adresu"
                           open-direction="bottom"
                           :options="addresses"
                           :multiple="false"
                           :searchable="true"
                           :internal-search="false"
                           :close-on-select="true"
                           :options-limit="300"
                           :limit="3"
                           :max-height="600"
                           :show-no-results="false"
                           @search-change="getResult"
                           @select="openAddress"
                           :clear-on-select="true"
                           selectLabel="">
                <template slot="option" scope="props">
                  <div class="option__desc">
                                                    <span class="option__title" :class="props.option.available === true ? 'available' : 'unavailable'">
                                                        <div class="row m-0 pb-1">
                                                            <div class="col-sm-6">{{ props.option.values.WHOLE_ADDRESS }}</div>
                                                        </div>
                                                        <div class="row m-0 font-sm">
                                                            <div class="col-sm-12">
                                                                <span>{{ props.option.values.DISTRICT }}</span>,&nbsp;
                                                                <span>{{ props.option.values.REGION }}</span>
                                                            </div>
                                                        </div>
                                                    </span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </template>
        <template v-else="">
          <div class="row justify-content-center">
            <div class="form-group col-md-12">
              <multiselect v-model="selected"
                           :reset-after="true"
                           id="searchForeign"
                           data-testid="registration-address-search-foreign"
                           label="label"
                           track-by="code"
                           placeholder="vyhledat adresu v cizině"
                           open-direction="bottom"
                           :options="foreignAddresses"
                           :multiple="false"
                           :searchable="true"
                           :internal-search="false"
                           :close-on-select="true"
                           :options-limit="300"
                           :limit="3"
                           :max-height="600"
                           :show-no-results="false"
                           @search-change="getForeignAddressResult"
                           @select="openForeignAddress"
                           :clear-on-select="true"
                           selectLabel="">
                <template slot="option" scope="props">
                  <div class="option__desc">
                                                    <span class="option__title" :class="props.option.available === true ? 'available' : 'unavailable'">
                                                        <div class="row m-0 pb-1">
                                                            <div class="col-sm-6">{{ props.option.description }}</div>
                                                        </div>
                                                    </span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </template>

        <div class="row justify-content-center">
          <div class="form-group col-md-9">
            <label for="street">Ulice</label>
            <input v-model="address.street" type="text" class="form-control" aria-describedby="streetHelp" id="street" data-testid="registration-address-street" disabled="disabled">
            <small id="streetError" class="form-text text-danger" v-if="addressError.street">{{ addressError.street.message }}</small>
          </div>
          <div class="form-group col-md-3">
            <label for="houseNumber">Číslo</label>
            <input v-model="address.house_number" type="text" class="form-control" aria-describedby="houseNumberHelp" id="houseNumber" data-testid="registration-address-house-number" disabled="disabled">
            <small id="houseNumberError" class="form-text text-danger" v-if="addressError.housenumber">{{ addressError.housenumber.message }}</small>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col-md-4">
            <label for="zip_code">PSČ</label>
            <input v-model="address.zip_code" type="text" class="form-control" aria-describedby="zip_codeHelp" id="zip_code" data-testid="registration-address-zip-code" disabled="disabled">
            <small id="zipCodeError" class="form-text text-danger" v-if="addressError.zipcode">{{ addressError.zipcode.message }}</small>
          </div>
          <div class="form-group col-md-8">
            <label for="city">Město</label>
            <input v-model="address.city" type="text" class="form-control" aria-describedby="cityHelp" id="city" data-testid="registration-address-city" disabled="disabled">
            <small id="cityError" class="form-text text-danger" v-if="addressError.city">{{ addressError.city.message }}</small>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col-md-6">
            <label for="district">Okres</label>
            <input v-model="address.district" type="text" class="form-control" aria-describedby="districtHelp" id="district" data-testid="registration-address-district" disabled="disabled">
            <small id="districtError" class="form-text text-danger" v-if="addressError.district">{{ addressError.district.message }}</small>
          </div>
          <div class="form-group col-md-6">
            <label for="region">Kraj</label>
            <input v-model="address.region" type="text" class="form-control" aria-describedby="regionHelp" id="region" data-testid="registration-address-region" disabled="disabled">
            <small id="regionError" class="form-text text-danger" v-if="addressError.region">{{ addressError.region.message }}</small>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col-md-12 text-center">
            <button v-if="addressPending === false" type="submit" class="btn btn-primary" data-testid="registration-address-save">Uložit adresu</button>
            <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
          </div>
        </div>
      </form>
      <div  v-if="waitForData" class="row justify-content-around">
        <div class="">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import _ from 'lodash'

  export default {
    data () {
      return {
        // client
        addressDone: false,
        addressPending: false,
        addressError: false,
        address: {
          country: 1,
          street: '',
          house_number: '',
          city: '',
          zip_code: '',
          district: '',
          region: '',
          full_maps_data: null
        },
        // others
        setting: require('../../../variables.js'),
        waitForResponse: false,
        waitForData: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: [],
        selected: '',
        addresses: [],
        foreignAddresses: [],
        foreignAddressDetail: {},
        toSearchText: '',
        toSearchForeignText: '',
        searchOutsideCzechia: false,
        foreignAddressDetailDone: false
      }
    },
    mixins: [apiMixin],
    methods: {
      submitForm () {
        this.postAddress(this.address, this.$route.params.clientid)
        // this.postAddress()
        /* if (!this.clientCreated) {
         } else {
         this.putClient()
         if (!this.addressCreated) {
         this.postAddress()
         } else {
         this.putAddress()
         }
         } */
      },
      // getCountries () {
      //   this.waitForData = true
      //   this.$http.get(this.setting.hostname + 'country').then(response => {
      //     this.countries = response.data
      //     // this.useGovData = true
      //     this.waitForData = false
      //   }, response => {
      //     this.waitForData = false
      //   })
      // },
      getResult (text) {
        this.toSearchText = text
      },
      getForeignAddressResult (text) {
        this.toSearchForeignText = text
      },
      openAddress (value) {
        this.address.street = value.values.STREET
        this.address.house_number = value.values.NUMBER
        this.address.city = value.values.CITY
        this.address.zip_code = value.values.ZIP
        this.address.district = value.values.DISTRICT
        this.address.region = value.values.REGION
      },
      openForeignAddress (value) {
        this.getForeignAddressDetail(value.place_id)
      }
    },
    beforeMount () {
      this.getCountries()
    },
    watch: {
      toSearchText: _.debounce(function (text) {
        this.searchAddresses(text)
      }, 500),
      addressDone (val) {
        if (val === true) {
          this.$router.push({name: 'ShowClient', params: { clientid: this.$route.params.clientid }})
        }
      },
      searchOutsideCzechia (val) {
        if (val === true) {
          this.address.country = null
        } else {
          this.address.country = 1
        }
      },
      toSearchForeignText: _.debounce(function (text) {
        this.searchForeignAddresses(text)
      }, 1500),
      foreignAddressDetailDone (val) {
        if (val === true) {
          this.addressForm.country = null
          this.addressForm.street = ''
          this.addressForm.house_number = ''
          this.addressForm.city = ''
          this.addressForm.zip_code = ''
          this.addressForm.district = ''
          this.addressForm.region = ''
          this.addressForm.full_maps_data = null

          let city = []
          for (var i = 0, len = this.foreignAddressDetail.address_components.length; i < len; i++) {
            let addressPart = this.foreignAddressDetail.address_components[i]
            if (addressPart.types.includes('street_number')) {
              this.address.house_number = addressPart.long_name
            }
            if (addressPart.types.includes('postal_code')) {
              this.address.zip_code = addressPart.long_name
            }
            if (addressPart.types.includes('locality')) {
              city[0] = addressPart.long_name
            }
            if (addressPart.types.includes('sublocality')) {
              city[1] = addressPart.long_name
            }
            if (addressPart.types.includes('route')) {
              this.address.street = addressPart.long_name
            }
            if (addressPart.types.includes('administrative_area_level_1')) {
              this.address.region = addressPart.long_name
            }
            if (addressPart.types.includes('administrative_area_level_2')) {
              this.address.district = addressPart.long_name
            }
          }
          city = city.filter(function (el) {
            return el != null
          })
          this.address.city = city.join(', ')
          this.address.full_maps_data = this.foreignAddressDetail
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .icon-male {
    color: dodgerblue;
    font-weight: bold;
  }

  .icon-female {
    color: deeppink;
    font-weight: bold;
  }

  .icon-genderless {
    color: #ccc;
    font-weight: bold;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    vertical-align: middle;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    text-align: left;
  }

  td.empty_cell {
    border-top: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Registration/components/RegistrationClientAddress.vue?3eab926d